import React from "react";
import { Global } from "@emotion/react";

function Theme() {
  return (
    <Global
      styles={`
      @media (prefers-color-scheme: dark) {
        body {
          color: var(--chakra-colors-text-primary) !important;
          background: white !important;
        }
      }
    `}
    />
  );
}

function Fonts() {
  return (
    <Global
      styles={`
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: italic;
      font-weight: 300;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-book-italic.woff2) format("woff2");
    }
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: normal;
      font-weight: 300;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-book.woff2) format("woff2");
    }
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: italic;
      font-weight: 400;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-medium-italic.woff2) format("woff2");
    }
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: normal;
      font-weight: 400;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-medium.woff2) format("woff2");
    }
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: italic;
      font-weight: 600;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-semibold-italic.woff2) format("woff2");
    }
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: normal;
      font-weight: 600;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-semibold.woff2) format("woff2");
    }
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: normal;
      font-weight: 700;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-bold.woff2) format("woff2");
    }
    @font-face {
      font-family: "Sharp Sans Display No 1";
      font-style: italic;
      font-weight: 700;
      font-display: block;
      src: url(/fonts/sharp-sans-disp-no-1-bold-italic.woff2) format("woff2");
    }
    @font-face {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400 500 600 700;
      font-display: swap;
      src: url(/fonts/inter-variable-font.ttf) format("truetype");
    }
    @font-face {
      font-family: 'Roboto Mono', monospace;
      font-style: normal;
      font-weight: 400 500 600 700;
      font-display: swap;
      src: url("https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@300;400;500;600;700&display=swap") format("woff2");
    }
    @font-face {
      font-family: "Nuckle";
      font-style: normal;
      font-weight: 400;
      font-display: block;
      src: url(/fonts/nuckle/nuckle-regular.woff2) format("woff2");
    }
    @font-face {
      font-family: "Nuckle";
      font-style: normal;
      font-weight: 600;
      font-display: block;
      src: url(/fonts/nuckle/nuckle-semi-bold.woff2) format("woff2");
    }
    @font-face {
      font-family: "Nuckle";
      font-style: normal;
      font-weight: 700;
      font-display: block;
      src: url(/fonts/nuckle/nuckle-bold.woff2) format("woff2");
    }
    `}
    />
  );
}

function Algolia() {
  return (
    <Global
      styles={`
      .ais-SearchBox-form {
        display: flex;
        width: 100%;
        align-items: center;
        position: relative;
      }

      .ais-SearchBox-input {
        width: 100%;
        padding: 18px;
        padding-left: 48px;
        font-size: 18px;
        border: 1px solid var(--chakra-colors-gray-500);
        border-radius: var(--chakra-radii-base) !important;
        min-height: 32px;
        background-color: white;
        flex: 1;
        font-family: "Sharp Sans Display No 1";
        transition: border-color 150ms;
        outline: none !important;

        &:hover {
          border: 1px solid var(--chakra-colors-gray-600);
        }

        &:focus {
          border-color: var(--chakra-colors-gray-700);
        }

        &::-webkit-search-cancel-button {
          display: none;
        }
      }

      .ais-SearchBox-submit {
        position: absolute;
        left: 20px;
      }

      .ais-SearchBox-reset {
        position: absolute;
        right: 20px;
        border: none;

        &:focus:not(:focus-visible) {
          outline: none !important;
        }
      }

      .ais-SearchBox-input::placeholder {
        color: var(--chakra-colors-gray-500);
        font-family: "Sharp Sans Display No 1";
        font-size: 18px;
      }

      .ais-SearchBox-resetIcon {
        width: 16px;
        height: 16px;
        fill: var(--chakra-colors-text-secondary);
      }

      .ais-SearchBox-loadingIndicator,
      .ais-SearchBox-submit {
        display: none;
      }
    `}
    />
  );
}

function Swiper() {
  return (
    <Global
      styles={`
      .swiper-pagination {
        bottom: 0 !important;
      }
      
      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        transition: .15s background-color ease-in-out;
      }

      .swiper-pagination-bullet--light {
        background: var(--chakra-colors-gray-400);
        opacity: 1;
      }

      .swiper-pagination-bullet-active--light {
        background: var(--chakra-colors-text-primary);
        opacity: 1;
      }

      .swiper-pagination-bullet--dark {
        background: #FFF;
        opacity: 0.3;
      }

      .swiper-pagination-bullet-active--dark {
        background: #FFF;
        opacity: 1;
      }
    `}
    />
  );
}

export function GlobalStyles() {
  return (
    <>
      <Theme />
      <Fonts />
      <Algolia />
      <Swiper />
    </>
  );
}
